import { Star } from 'lucide-react';

/** Small filled/outline star row for a 1-5 rating. `rating` may be absent (testimonials). */
export function Stars({ rating, size = 14 }: { rating?: number | null; size?: number }) {
  if (rating == null) return <span className="text-[13px] text-muted-foreground">—</span>;
  return (
    <div className="flex items-center gap-0.5" aria-label={`${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          className={n <= rating ? 'fill-amber-400 text-amber-400' : 'fill-none text-[#D9D9D9]'}
        />
      ))}
    </div>
  );
}
